module.exports = __webpack_public_path__ + "img/Group 1422 (2).fc64796c.png";